import styled from 'styled-components';
import BannerAcceptComCom from './BannerAcceptComCom';
import { colorSchema } from 'utils/style';

export default styled(BannerAcceptComCom)`
  .banner-accept-com-com {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 2.4rem;
      font-weight: bold;
      margin-bottom: 0.8rem;
    }

    &__body {
      color: ${colorSchema('grey700')};
      font-size: 1.8rem;
      line-height: 1.28;
      margin: 1.6rem 0;
    }
  }
`;
